<template>
  <div style="display: flex;justify-content: center;min-height:100vh">
    <div style="display: flex;flex-direction:column;width: 100%;max-width: 1400px;min-width: 1000px">
      <div style="display: flex;align-items: center;padding-top: 20px">
        <img src="../assets/img/logo.jpg" style="width: 40px;height:auto" />
        <span style="margin-left: 20px;font-size:28PX">收银宝Api开发文档2.0</span>
        <div style="margin-left: 100px;font-weight: bold;font-size:26px;color:#6ec715">Restful API网关: https://www.yqdfpay.com</div>
      </div>
      <div style="color:red;margin-left:300px;margin-top:15px">建议所有Number字段采用字符串接收，验签后再转为相应数据类型，以防因数字格式问题导致验签失败</div>

      <div style="padding-top: 30px;height: 100%"  v-loading="loading" element-loading-text="文档生成中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)">
        <el-tabs v-model="curIndex" tab-position="left" style="height: 100%;">
          <el-tab-pane v-for="item in list" lazy :key="item.id" :label="item.name">
            <div class="api-body">
              <div class="name">{{item.name}}</div>
              <div v-if="item.path" style="display: flex;margin-top:20px;align-items: center">
                <div style="display: flex;align-items: center;border-radius: 5px;background-color: #e5e7ea99;width:400px;padding:10px;20px">
                  <el-tag type="warning" effect="dark">{{ item.method }}</el-tag>
                  <span style="margin-left: 10px">/api/third/v2.0/{{item.path}}</span>
                </div>
                <div>
                  <el-button @click="showDebug(item)" type="primary" style="margin-left: 16px;">
                    <i class="el-icon-caret-right"></i>
                    <span>调试</span>
                  </el-button>
                </div>
              </div>
              <div v-if="item.description" style="padding:30px 0 0">
                <div v-html="item.description"></div>
              </div>
              <div v-if="item.param && item.param.paramList && item.param.paramList.length>0" style="margin-top:30px">
                <span style="font-size: 25px">请求参数</span>
                <div>
                  <expandable-table :data="item.param.paramList" show-require></expandable-table>
                </div>

                <div style="margin-top:30px" v-if="item.showSample">
                  <span style="font-size: 25px">请求示例</span>
                  <div style="background: #2d2d2d;padding: 30px 0 ; border: 1px solid #ddd;">
                    <prism-editor class="my-editor" v-model="item.requestCode" :highlight="highlighter" line-numbers readonly></prism-editor>
                  </div>
                </div>
              </div>
              <div v-if="item.response && item.response.paramList && item.response.paramList.length>0" style="margin-top:30px">
                <span style="font-size: 25px">响应</span>
                <div>
                  <expandable-table :data="item.response.paramList"></expandable-table>
                </div>

                <div style="margin-top:30px">
                  <span style="font-size: 25px">响应示例</span>
                  <div style="background: #2d2d2d;padding: 30px 0 ; border: 1px solid #ddd;">
                    <prism-editor class="my-editor" v-model="item.responseCode" :highlight="highlighter" line-numbers readonly></prism-editor>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

    <el-drawer title="调试窗口" :visible.sync="debugVisible" direction="rtl" :modal="false">
      <div v-if="debugVisible">
        <div style="padding: 10px 30px;border:1px solid red">
          <div style="display: flex;align-items: center">
            <div style="width:100px">终端授权码</div>
            <div style="padding-left: 20px">
              <el-input @input="refreshDebug" v-model="apiSetting.terminalCode"></el-input>
            </div>
          </div>
          <div style="display: flex;align-items: center;margin-top: 10px">
            <div style="width:100px">授权密码</div>
            <div style="padding-left: 20px">
              <el-input v-model="apiSetting.key"></el-input>
            </div>
          </div>
        </div>
        <el-table :stripe="true" size="mini" :data="debugMethod.originParamList">
          <cust-table-column width="200" prop="name" label="字段" />
          <cust-table-column label="值">
            <template slot-scope="scope">
              <el-input v-model="debugForm[scope.row.name]"></el-input>
            </template>
          </cust-table-column>
        </el-table>
        <el-button @click="sendDebug" type="primary" style="margin-left: 16px;margin-top:15px">发送</el-button>

        <div style="padding-top: 20px;padding-left:15px">
          <div><span>签名字符串</span></div>
          <pre class="language-javascript"><code>{{signStr}}</code></pre>
        </div>
        <div style="padding-top: 20px;padding-left:15px">
          <div><span>签名值</span></div>
          <pre class="language-javascript"><code>{{signVal}}</code></pre>
        </div>
        <div style="padding-top: 20px;padding-left:15px">
          <div>
            <span>请求数据</span>
            <span style="margin-left: 12px;color:green">https://www.yqdfpay.com/api/third/v2.0/{{debugMethod.path}}</span>
          </div>
          <div style="background: #2d2d2d;padding: 30px 0 ; border: 1px solid #ddd;">
            <prism-editor class="my-editor" v-model="debugFormCode" :highlight="highlighter" line-numbers readonly></prism-editor>
          </div>
        </div>
        <div style="padding-top: 20px;padding-left:15px">
          <div>响应数据</div>
          <div style="background: #2d2d2d;padding: 30px 0 ; border: 1px solid #ddd;">
            <prism-editor class="my-editor" v-model="debugResponse" :highlight="highlighter" line-numbers readonly></prism-editor>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import request from '../utils/request'
import CryptoJS from 'crypto-js';
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';
import ExpandableTable from "@/components/ExpandableTable/index.vue";
import CustTableColumn from "@/components/CustTableColumn/index.vue"; // import syntax highlighting styles
export default {
  components: {
    CustTableColumn,
    ExpandableTable,
    PrismEditor,
  },
  data() {
    return {
      loading:true,
      list:[],
      curIndex:'',
      typeList:[
        {name:'String', value:0},
        {name:'Number', value:1},
        {name:'Boolean', value:2},
        {name:'Object', value:3},
        {name:'Array', value:4}
      ],
      apiSetting:{
        terminalCode:'',
        key:''
      },
      debugMethod:undefined,
      debugVisible: false,
      debugForm:{},
      debugResponse:'{}',
      globalParamList1:[
        {
          "type": 0,
          "name": "terminalCode",
          "description": "终端授权码",
          "required": true,
          "sample": "10807",
          "showSample": true
        }
      ],
      globalParamList2:[
        {
          "type": 0,
          "name": "nonceStr",
          "description": "随机字符串",
          "required": true,
          "sample": "werwefwef3",
          "showSample": true
        },
        {
          "type": 0,
          "name": "sign",
          "description": "签名：除sign外所有非空字段字典序排序后以key1=value1&key2=value2形式拼接，最后拼接&key=终端支付密码成为签名字符串，对签名字符串计算32位小写MD5散列值，即为签名",
          "required": true,
          "sample": "ca80d47c792e78048685c45c5cafb953",
          "showSample": true
        }
      ],
      globalResList:[
        {
          "type": 1,
          "name": "code",
          "description": "状态码 0为成功，非0为出错",
          "sample": "0",
          "showSample": true
        },
        {
          "type": 0,
          "name": "errMsg",
          "description": "错误信息",
          "sample": "",
          "showSample": true
        }
      ]
    };
  },
  created() {
    this.loading = true;
    request.get('https://www.yqdfpay.com/api/doc/list').then(res => {
      this.loading = false;
      if(res.code === 0) {
        this.list = res.data.map(item => {
          if(item.param && item.param.paramList && item.param.paramList.length > 0 && item.globalRes){
            item.originParamList = [...item.param.paramList];
            item.param.paramList.splice(0, 0, ...this.globalParamList1);
            item.param.paramList.push(...this.globalParamList2);
          }

          if(item.response && item.response.paramList && item.response.paramList.length>0 && item.globalRes){
            if(item.response.paramList.length === 1 && item.response.paramList[0].name === 'code'){
              item.response.paramList = [...this.globalResList]
            }else{
              item.response.paramList.splice(0, 0, ...this.globalResList);
            }
          }

          const requestCode = this.createSample(item.param);
          const responseCode = this.createSample(item.response)

          item.description

          return {
            ...item,
            requestCode: JSON.stringify(requestCode, null, 4),
            responseCode: JSON.stringify(responseCode, null, 4),
          }
        })
      }
    }).catch(err => {
      this.loading = false;
      console.info(err)
    })
  },
  computed:{
    debugFormCode(){
      return JSON.stringify(this.debugForm, null, 4);
    },
    signStr(){
      const test = this.apiSetting.terminalCode
      return Object.keys(this.debugForm)
          .filter(key => key !== 'sign')
          .sort() // 按字典序排序
          .map(key => `${key}=${this.debugForm[key]}`) // 转换成 key=value 形式
          .join('&')+"&key="+this.apiSetting.key
    },
    signVal(){
      return  CryptoJS.MD5(this.signStr).toString();
    }
  },
  watch: {
    signVal(sign) {
      this.debugForm.sign = sign
    }
  },
  methods: {
    createSample(model){
      if(!model){
        return null;
      }
      const result = {}
      model.paramList
          .filter(item => item.showSample)
          .forEach(item =>{
            if(item.referModelDetail){
              if(item.type === 3){
                if(item.type === 0){
                  result[item.name] = JSON.stringify(this.createSample(item.referModelDetail))
                }else{

                  result[item.name] = this.createSample(item.referModelDetail)
                }
              }else{
                if(item.type === 0){
                  result[item.name] = JSON.stringify([
                    this.createSample(item.referModelDetail),
                    this.createSample(item.referModelDetail)
                  ])
                }else{
                  result[item.name] = [
                    this.createSample(item.referModelDetail),
                    this.createSample(item.referModelDetail)
                  ]
                }
              }
            }else{
              switch (item.type) {
                case 1:
                  result[item.name] = parseFloat(item.sample)
                  break;
                case 2:
                  result[item.name] = item.sample.toUpperCase() == "TRUE"
                  break;
                default:
                  result[item.name] = item.sample
                  break;
              }

            }
          });
      return result
    },
    highlighter(code) {
      return highlight(code, languages.js); // languages.<insert language> to return html with markup
    },
    showDebug(method){
      if(this.debugMethod !== method){
        this.debugForm = {};
        this.debugResponse = "";
      }

      this.debugForm.terminalCode=this.apiSetting.terminalCode;
      this.debugForm.nonceStr=CryptoJS.lib.WordArray.random(5).toString();
      this.debugMethod =method
      this.debugVisible=true
    },
    sendDebug(){
      request.post(`https://www.yqdfpay.com/api/third/v2.0/${this.debugMethod.path}`, this.debugForm).then(res=>{
        this.debugResponse = JSON.stringify(res, null, 4)
      })
    },
    refreshDebug(){
      this.debugForm.terminalCode=this.apiSetting.terminalCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.api-body{
  color: #344054;
  padding-left:30px;
  .name{
    font-size: 32px;
  }
}

</style>
